import script from "./global-search.vue?vue&type=script&setup=true&lang=js"
export * from "./global-search.vue?vue&type=script&setup=true&lang=js"

import "./global-search.vue?vue&type=style&index=0&id=6282aa3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6282aa3c"]])

export default __exports__